export const locale = {
    lang: 'en',
    data: {
        LANDING_APPOINTMENT_CARD: {
            TITLES: {
                CONFIRMED: 'Confirmed',
                PENDING: 'Pending',
            }
        }
    }
};